import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'
import { Loader } from '../../../../common/components';

const ListEmailTemplatePage = loadable(() => import('./ListEmailTemplatePage'), {
    fallback: <Loader/>,
});
const EditEmailTemplatePage = loadable(() => import('./EditEmailTemplatePage'), {
    fallback: <Loader/>,
});
const AddEmailTemplatePage = loadable(() => import('./AddEmailTemplatePage'), {
    fallback: <Loader/>,
});


const EmailTemplateRoutes = ({ t, alert }) => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListEmailTemplatePage t={t} alert={alert} />} />
      <Route exact path="/edit/:email_template_id" element={<EditEmailTemplatePage t={t} alert={alert} />} />
      <Route exact path="/add" element={<AddEmailTemplatePage t={t} alert={alert} />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};
EmailTemplateRoutes.propTypes = {
  t: PropTypes.func
};
export default EmailTemplateRoutes;
